<template>
  <div id="technical-solution">
    <div class="open-platform-header">
      <h1>{{ lanInfo.title[5] }}</h1>
      <p class="">{{ lanInfo.solution.desc }}</p>
    </div>
    <div class="content-width">
      <div class="solution-headers">
        <span
            :class="{active: index == indexList.header}"
            v-for="(item,index) of lanInfo.solution.headers"
            v-bind:key="index"
            @click="actionItem('header', index)">
          {{ item }}
        </span>
      </div>

      <div class="solution-details">
        <div class="detail-left">
          <div
              class="solution-type"
              :class="{active: index == indexList.content}"
              v-for="(item,index) of lanInfo.solution.content[indexList.header]">
            <span @mouseover="actionItem('content',index)" :title="item.type">{{ item.type }}</span>
          </div>
        </div>
        <div class="detail-right">
          <div class="solution-details-item">
            <img
                :src="require(`../../assets/images/openPlatform/detail-solution-${indexList.header + 1}-${indexList.content + 1}.png`)">
            <div class="solution-details-item-content" v-if="lanType == 'cn'">
              <h2>{{ lanInfo.solution.contentHeaders[indexList.header][0] }}</h2>
              <p>
                <template v-for="(item,index) of lanInfo.solution.content[indexList.header][indexList.content].pain">
                  {{ item }} <br>
                </template>
              </p>

              <h2>{{ lanInfo.solution.contentHeaders[indexList.header][1] }}</h2>
              <p>
                <template
                    v-for="(item,index) of lanInfo.solution.content[indexList.header][indexList.content].solution">
                  {{ item }} <br>
                </template>
              </p>
            </div>
            <div class="solution-details-item-content-en" v-if="lanType == 'en'">
              <div class="content-headers">
                <div class="content-header-item" :class="{active: 0 == indexList.contentDetail}"
                     @mouseover="actionItem('contentDetail',0)">
                  {{ lanInfo.solution.contentHeaders[indexList.header][0] }}
                </div>
                <div class="content-header-item" :class="{active: 1 == indexList.contentDetail}"
                     @mouseover="actionItem('contentDetail',1)">
                  {{ lanInfo.solution.contentHeaders[indexList.header][1] }}
                </div>
              </div>
              <div class="content-detail">
                <template v-if="indexList.contentDetail == 0">
                  <template v-for="(item,index) of lanInfo.solution.content[indexList.header][indexList.content].pain">
                    {{ item }} <br>
                  </template>
                </template>
                <template v-if="indexList.contentDetail == 1">
                  <template
                      v-for="(item,index) of lanInfo.solution.content[indexList.header][indexList.content].solution">
                    {{ item }} <br>
                  </template>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "openPlatformDetailSolution",
  computed: {
    lanInfo() {
      return this.$store.getters.getLanInfo.openPlatform;
    },
    lanType() {
      return this.$store.getters.getLanType;
    }
  },
  data() {
    return {
      indexList: {
        header: 0,
        content: 0,
        contentDetail: 0
      }
    }
  },
  methods: {
    actionItem(name, index) {
      if (name == 'header') {
        this.indexList.content = 0;
      }
      this.indexList[name] = index;
    },
  }
}
</script>

<style scoped lang="scss">
.open-platform-header {
  text-align: center;
  padding-top: 40px;

  h1 {
    color: #000000;
    font-size: 26px;
  }

  p {
    color: #0080FF;
    font-size: 16px;
    margin-top: 15px;
    margin-bottom: 30px;
  }
}

.content-width {
  width: 1200px;
  margin: 0 auto;
}

#technical-solution {
  padding-bottom: 60px;
  background: #F5F5F5;
}

.solution-headers {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  span {
    background: #E2EBF8;
    border: 1px solid #2D84FF;
    font-weight: bolder;
    color: #418FFE;
    line-height: 42px;
    font-size: 16px;
    width: 162px;
    margin-right: 10px;
    height: 42px;
    cursor: pointer;

    &.active {
      background: #2D84FF;
      color: #fff;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

.solution-details {
  display: flex;
  flex-direction: row;
  margin-top: 35px;

  .detail-left {
    display: flex;
    flex-direction: column;
    background: transparent;
    width: 202px;
    flex-shrink: 0;
    margin-right: 10px;

    .solution-type {
      cursor: pointer;

      span {
        width: 192px;
        height: 57px;
        display: block;
        line-height: 56px;
        padding-left: 28px;
        padding-right: 28px;
        background: #DFE9F8;
        margin: auto;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      &.active {
        background: #2D84FF;

        span {
          background: #2D84FF;
          color: #fff;
        }
      }

    }
  }

  .detail-right {
    height: 399px;
    background: #DFE9F8;
    padding-top: 36px;
    padding-left: 20px;
    flex: 1;
    padding-right: 20px;

    .solution-details-item {
      display: flex;

      img {
        width: 542px;
        height: 316px;
        flex-shrink: 0;
      }

      .solution-details-item-content {
        margin-left: 20px;
        flex: 1;

        h2 {
          font-weight: 600;
          color: #0F0F0F;
          font-size: 16px;
        }

        p {
          font-size: 14px;
          color: #646464;
          line-height: 20px;
          margin-bottom: 20px;
        }

      }

      .solution-details-item-content-en {
        margin-left: 20px;
        flex: 1;

        .content-headers {
          display: flex;
          flex-direction: row;
          margin-bottom: 20px;

          .content-header-item {
            font-weight: 600;
            color: #0F0F0F;
            font-size: 16px;
            margin-right: 20px;
            border-bottom: 2px solid transparent;
            padding-bottom: 6px;
            cursor: pointer;

            &.active {
              border-bottom: 2px solid #2D84FF;
            }
          }
        }

        .content-detail {
          font-size: 14px;
          color: #646464;
          line-height: 20px;
          margin-bottom: 20px;
        }
      }
    }

  }
}
</style>